import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { app, db } from "../../firebase";
import { collection,getDocs, query, where, onSnapshot, doc} from "firebase/firestore";

const CountsOfComments = (props) => {
    const dispatch = useDispatch()
    const [comments, setCommentCounts] = useState([])
    const [replies, setReplyCounts] = useState([])
 
    useEffect(() => {
        if (props.postid) {
            const getCounts = async () => {
                const cRef = collection(db, "communityComments")
                const q = query(cRef, where("postid", "==", props.postid));
                const querySnapshot = await getDocs(q);
                let commentsDoc = [];
                querySnapshot.forEach( (doc) => {
                    let cd = doc.data()
                    if (cd.postid == props.postid) {
                        commentsDoc.push(cd)
                    }
                   
                });
                setCommentCounts(commentsDoc)  
            }
            getCounts()
        }
    }, [])

    //Real Time Change
    useEffect(() => {
        const cc = onSnapshot(
            collection(db, "communityComments"), where("postid", "==", props.postid),
            (snapshot) => {
                let commentCount = [];
                snapshot.docs.forEach((doc) => { 
                    let comment = doc.data()
                    if (comment.postid == props.postid) {
                        commentCount.push(doc.data())
                    } 
                })
                setCommentCounts(commentCount);
            },
            (error) => {
                console.log(error)
            }
        );
        return () => {
            cc()
        }
    }, [])


     const focusOnComment = (e,id) =>{
        // document.getElementById("commentInput-"+id).focus();  
    }

    return (
         
        <>
            {
                comments ?
                    <>
                        { comments.length ? <> <a  onClick={e => focusOnComment(e, props.postid)} className="text-decoration-none text-dark ">{comments.length} Comment</a> </> : ''} 
                    </> 
                : ''
            }     
          
        </>

    )

}

const mapStateToProps = state  => {
    return {
        userDetails: state.loginAuth.userDetails,
    }  
}

export default connect(mapStateToProps)(CountsOfComments)
